import _regeneratorRuntime from "@babel/runtime/regenerator";
import { loadToHTMLImage } from './parse-to-html-image';
export default function parseSVG(arrayBuffer, options) {
  var textDecoder, xmlText, src;
  return _regeneratorRuntime.async(function parseSVG$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          textDecoder = new TextDecoder();
          xmlText = textDecoder.decode(arrayBuffer);
          src = "data:image/svg+xml;base64,".concat(btoa(xmlText));
          _context.next = 5;
          return _regeneratorRuntime.awrap(loadToHTMLImage(src, options));

        case 5:
          return _context.abrupt("return", _context.sent);

        case 6:
        case "end":
          return _context.stop();
      }
    }
  });
}